import { render } from "./MassAssignRoles.vue?vue&type=template&id=1391f28e"
import script from "./MassAssignRoles.vue?vue&type=script&lang=js"
export * from "./MassAssignRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__